import Repository from "../../repository";

export default {
    GetListMobileMenuByGroupID: (payload) => Repository.post(`/api/menu/GetListMobileMenuByGroupID`, payload),
    GetMobileMenu: (payload) => Repository.post(`/api/menu/GetMobileMenu`, payload),
    EditMobileMenu: (payload) => Repository.post(`/api/menu/EditMobileMenu`, payload),
}